module.exports = __webpack_public_path__ + "static/media/photo310.e4f5fa1c.jpg";